module.exports = new __parcel__URL__("product5.61f22220.jpg").toString();